module.exports = __webpack_public_path__ + "static/media/photoadd.97328254.svg";